'use client';

import { useEffect } from 'react';
import { IntercomProvider, useIntercom } from 'react-use-intercom';
import type { User } from '@/types/user';
import { zoned } from '@/utils/dates';

const IntercomHelper = ({ user }: { user: User | null }) => {
  const { boot } = useIntercom();

  useEffect(() => {
    if (!user) return;

    boot({
      name: user.name,
      email: user.email,
      // @ts-expect-error custom intercom prop
      job_title: user.jobTitle,
      roles: user.roles.join(','),
      createdAt: zoned(user.created).getTime() / 1000,
      ...(user.company?.id && user.company.name
        ? { company: { companyId: user.company.id, name: user.company.name } }
        : {}),
      userId: user.intercomUserId,
      userHash: user.intercomHash,
    });
  }, [user, boot]);

  return null;
};

const Provider = ({ children, user, nonce }: { children: React.ReactNode; user: User | null; nonce?: string }) => {
  const INTERCOM_APP_ID = user?.intercomAppId || '';

  return (
    <IntercomProvider
      appId={INTERCOM_APP_ID}
      cspNonce={nonce}
    >
      <IntercomHelper user={user} />
      {children}
    </IntercomProvider>
  );
};

export { Provider };
